/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { Try } from 'framework/Try';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';

export async function eid_read(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IEidReadResponse>> {
	try {
		let url_ = '/api/eid/read';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_build(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
	try {
		let url_ = '/api/meta/build';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_ping(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
	try {
		let url_ = '/api/meta/ping';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export interface IEidData {
	surName: string;
	firstNames: string;
	dateOfBirth: Date;
	cardNumber: string;
	nationality: string;
	gender: string;
	addressStreetAndNumber: string;
	addressZip: string;
	addressMunicipality: string;
	socialSecurityNumber: string;
	locationOfBirth: string;
	issuedMunicipality: string;
	validityBeginDate: Date;
	validityEndDate: Date;
	photo: string | undefined;
}

export interface IEidReadResponse {
	data: IEidData;
	errorNoMiddleWareInstalled: boolean;
	errorNoReaderConnected: boolean;
	errorNoCardInserted: boolean;
	unknownError: string | undefined;
	hasError: boolean;
	isSuccess: boolean;
}
